import type { InferGetStaticPropsType } from 'next';
import Head from 'next/head';
import type { ReactElement } from 'react';

import BlogsList from '@/components/Blog/BlogsList';
import Layout from '@/components/Landing/Layout';
import { getStaticBlogsListProps } from '@/utils/getStaticBlog';
import { createBreadcrumbSchema } from '@/utils/schema-org';
import { createMetaTags } from '@/utils/seo';

const PressRoom = ({
  initialPages,
}: InferGetStaticPropsType<typeof getStaticProps>) => {
  return (
    <>
      <Head>
        {createMetaTags({
          title: 'MindPal - AI tools updates',
          description:
            'AI solutions and HR automation. Intelligent bots, process automation, and modern tools that transform the way HR teams work',
        })}
        <link
          rel="canonical"
          href="https://mindpal.co/press-room"
          key="canonical"
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'CollectionPage',
              name: 'Pressroom — MindPal',
              description:
                'Latest news, product updates and announcements from MindPal — AI-powered resume and career tools.',
              url: 'https://mindpal.co/press-room',
              publisher: {
                '@type': 'Organization',
                name: 'MindPal',
                url: 'https://mindpal.co',
              },
            }),
          }}
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(createBreadcrumbSchema('/press-room')),
          }}
        />
      </Head>
      <BlogsList
        initialPages={initialPages}
        blogType="PRESSROOM"
        title="Pressroom"
        description=""
      />
    </>
  );
};

export default PressRoom;

PressRoom.getLayout = (page: ReactElement) => (
  <Layout theme="light">{page}</Layout>
);

export const getStaticProps = async () => {
  const { initialPages } = await getStaticBlogsListProps({
    blogType: 'PRESSROOM',
  });

  return { props: { initialPages }, revalidate: 30 };
};
